import { render, staticRenderFns } from "./unitselector.vue?vue&type=template&id=394d118d&scoped=true"
import script from "./unitselector.vue?vue&type=script&lang=js"
export * from "./unitselector.vue?vue&type=script&lang=js"
import style0 from "./unitselector.vue?vue&type=style&index=0&id=394d118d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d118d",
  null
  
)

export default component.exports